// extracted by mini-css-extract-plugin
export default {"team-list-page__title":"teamListPage_team-list-page__title__9eCww","header":"teamListPage_header__UNX-8"};